export default __webpack_public_path__ + "static/media/backgroundImg.d82b75ec.webp";